import { useTranslation } from 'react-i18next';
import { S, DataCard } from '../../regureStyles';

const ConfigTab = ({ carrier, config, setConfig, savingCfg, cfgSaved, handleSaveConfig }) => {
  const { t } = useTranslation();
  return (
    <div style={{ maxWidth: 560 }}>
      <div style={{ fontSize: 15, fontWeight: 700, color: S.textPrimary, marginBottom: 4 }}>{t('screens.riskCarriers.cfgTitle', { defaultValue: 'Bordereaux Configuration' })}</div>
      <div style={{ fontSize: 13, color: S.textMuted, marginBottom: 20 }}>{t('screens.riskCarriers.cfgSubtitle', { name: carrier.name, defaultValue: 'Configure automatic bordereaux generation for {{name}}.' })}</div>

      <DataCard>
        <div style={{ fontSize: 13, fontWeight: 700, color: S.textPrimary, marginBottom: 14 }}>{t('screens.riskCarriers.cfgSchedule', { defaultValue: 'Schedule' })}</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 5 }}>{t('screens.riskCarriers.cfgFrequency', { defaultValue: 'Frequency' })}</div>
            <select
              value={config.frequency || 'monthly'}
              onChange={e => setConfig(c => ({ ...c, frequency: e.target.value }))}
              style={{
                width: '100%',
                padding: '9px 12px',
                background: S.bgCard,
                border: `1px solid ${S.borderLight}`,
                borderRadius: 8,
                fontSize: 13,
                color: S.textPrimary,
                outline: 'none',
              }}
            >
              <option value='monthly'>{t('screens.riskCarriers.cfgFreqMonthly',   { defaultValue: 'Monthly' })}</option>
              <option value='quarterly'>{t('screens.riskCarriers.cfgFreqQuarterly',{ defaultValue: 'Quarterly' })}</option>
              <option value='on_demand'>{t('screens.riskCarriers.cfgFreqOnDemand', { defaultValue: 'On Demand Only' })}</option>
            </select>
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 5 }}>{t('screens.riskCarriers.cfgDayOfMonth', { defaultValue: 'Day of Month' })}</div>
            <input
              type='number'
              min='1'
              max='28'
              value={config.dayOfMonth || 5}
              onChange={e => setConfig(c => ({ ...c, dayOfMonth: Number(e.target.value) }))}
              style={{
                width: '100%',
                padding: '9px 12px',
                background: S.bgCard,
                border: `1px solid ${S.borderLight}`,
                borderRadius: 8,
                fontSize: 13,
                color: S.textPrimary,
                outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 5 }}>{t('screens.riskCarriers.cfgDefaultFormat', { defaultValue: 'Default Format' })}</div>
            <select
              value={config.format || 'xlsx'}
              onChange={e => setConfig(c => ({ ...c, format: e.target.value }))}
              style={{
                width: '100%',
                padding: '9px 12px',
                background: S.bgCard,
                border: `1px solid ${S.borderLight}`,
                borderRadius: 8,
                fontSize: 13,
                color: S.textPrimary,
                outline: 'none',
              }}
            >
              <option value='xlsx'>{t('screens.riskCarriers.cfgFormatXlsx', { defaultValue: 'Excel (.xlsx)' })}</option>
              <option value='csv'>{t('screens.riskCarriers.cfgFormatCsv',   { defaultValue: 'CSV (.csv)' })}</option>
              <option value='json'>{t('screens.riskCarriers.cfgFormatJson', { defaultValue: 'JSON (.json)' })}</option>
            </select>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '9px 12px',
                background: S.bgCard,
                border: `1px solid ${S.borderLight}`,
                borderRadius: 8,
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 500, color: S.textPrimary }}>{t('screens.riskCarriers.cfgAutoSend', { defaultValue: 'Auto-Send' })}</div>
                <div style={{ fontSize: 11, color: S.textMuted }}>{t('screens.riskCarriers.cfgAutoSendDesc', { defaultValue: 'Send automatically on schedule' })}</div>
              </div>
              <button
                onClick={() => setConfig(c => ({ ...c, autoSend: !c.autoSend }))}
                style={{
                  width: 44,
                  height: 24,
                  borderRadius: 12,
                  border: 'none',
                  background: config.autoSend ? S.burgundy : '#cbd5e1',
                  cursor: 'pointer',
                  position: 'relative',
                  transition: 'background 0.2s',
                }}
              >
                <span
                  style={{
                    position: 'absolute',
                    top: 2,
                    left: config.autoSend ? 22 : 2,
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    background: '#fff',
                    transition: 'left 0.2s',
                  }}
                />
              </button>
            </div>
          </div>
        </div>

        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 5 }}>{t('screens.riskCarriers.cfgRecipients', { defaultValue: 'Recipient Emails' })}</div>
          <textarea
            value={(config.recipients || []).join('\n')}
            onChange={e =>
              setConfig(c => ({
                ...c,
                recipients: e.target.value
                  .split('\n')
                  .map(s => s.trim())
                  .filter(Boolean),
              }))
            }
            placeholder='one@carrier.com&#10;two@carrier.com'
            rows={3}
            style={{
              width: '100%',
              padding: '9px 12px',
              background: S.bgCard,
              border: `1px solid ${S.borderLight}`,
              borderRadius: 8,
              fontSize: 13,
              color: S.textPrimary,
              outline: 'none',
              resize: 'vertical',
              fontFamily: 'inherit',
              boxSizing: 'border-box',
            }}
          />
          <div style={{ fontSize: 11, color: S.textMuted, marginTop: 4 }}>{t('screens.riskCarriers.cfgRecipientsHint', { defaultValue: 'One email per line.' })}</div>
        </div>
      </DataCard>

      <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
        <button
          onClick={handleSaveConfig}
          disabled={savingCfg}
          style={{
            padding: '10px 22px',
            background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            opacity: savingCfg ? 0.6 : 1,
          }}
        >
          {savingCfg ? t('screens.riskCarriers.cfgSavingBtn', { defaultValue: 'Saving…' }) : t('screens.riskCarriers.cfgSaveBtn', { defaultValue: 'Save Configuration' })}
        </button>
        {cfgSaved && <span style={{ fontSize: 13, color: '#10b981', fontWeight: 600, alignSelf: 'center' }}>{t('screens.riskCarriers.cfgSavedOk', { defaultValue: '✓ Saved' })}</span>}
      </div>
    </div>
  );
};

export default ConfigTab;
